import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  CircularProgress,
  Divider,
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  Autocomplete
} from "@material-ui/core";
import {
  AddRefrenceDataList,
  getRefrenceDataList,
  PutRefrenceDataList,
  deleteItem,
  getRefrenceDataListForOneRecord ,
} from "../adminaction";
import CustomSnackbar from "../../../../CustomSnackbar";
import { makeStyles } from "@material-ui/styles";
import { Backdrop } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import { dashboardStyle } from "../../Components/InvoiceDetails/style";
import { ArrowBack, Delete, Error } from "@mui/icons-material";


const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const useStyles = makeStyles(dashboardStyle);

export default function InvoiceTypeModel({
  setOpenModel,
  getdata,
  updateId,
  setUpdateId,
  togglebutton,
  settogglebutton,
  deleteId,
  setDeleteID,
  setSuccessMessage,
  setErrorMessage,
  getdataFromID,
  setGetDataFromID,
  setGetData,
  loader,
  setLoader,
  setSearchAPi
  
}) {
  const [open, setOpen] = useState(false);
  // const [locationOption, setLocationOption] = React.useState([]);
  const [checked, setChecked] = useState(false);
  const [reviewerchecked, setReviewerChecked] = useState(false);
  const [enable, setEnable] = useState(false);
  
  const classes = useStyles();

  const [formState, setFormState] = useState({
    referenceId: 0,
    referenceKey: "InvoiceType",
    referenceCode: "",
    referenceText: "",
    referenceProp1: "",
    referenceProp2: "LowValue",
    referenceProp3: "false",
    referenceProp4: "",
    referenceProp5: false,
    isActive: true,
    employeeGrade:""
  });

  
  const submitHandler = (e, w) => {
    e.preventDefault();
    
    if (updateId) {
      PutRefrenceDataList(formState,setFormState,setSuccessMessage,setErrorMessage,setLoader,
  setGetData,
  handleClose,
  setSearchAPi
        );

    } else {

      AddRefrenceDataList(
        formState,
        setFormState,
        setLoader,
        setSuccessMessage,
        setErrorMessage,
  setGetData,

      handleClose

      );
      // getRefrenceDataList("InvoiceType",setGetData,()=>{},()=>{},()=>{},()=>{},()=>{},()=>{});
    }
  };
 
useEffect(() => {

  
}, [loader]);
  
  const enableDisable = () => {
    PutRefrenceDataList(
  formState,
  setFormState,
  setSuccessMessage,
  setErrorMessage,
  setLoader,
  setGetData,
  handleClose,
  setSearchAPi


    );

    
  };
  const Delete = () => {
    deleteItem(
      formState,
      setFormState,
      deleteId,
      setLoader,
      setSuccessMessage,
      setErrorMessage,
  setGetData,

    handleClose

    );
  };

  // const get_Location = () => {
  //   var axios = require("axios");

  //   var config = {
  //     method: "get",
  //     url: `${process.env.REACT_APP_API_URL}/api/Locations/GetLocations`,
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("user_token")}`,
  //     },
  //   };

  //   axios(config)
  //     .then(function (response) {
  //       setLocationOption(response.data);
  //       // setRoleoptions(
  //       //   response.data.map((item, i) => {
  //       //     return {
  //       //       value: item.id,
  //       //       label: item.name,
  //       //     };
  //       //   })
  //       // );
  //     })
  //     .catch(function (error) {});
  // };
  const clearState = (setFormState,setUpdateId,setDeleteID, settogglebutton,setGetDataFromID) => {
    setFormState((formState) => ({
      ...formState,
      referenceId: 0,
      referenceKey: "InvoiceType",
      referenceCode: "",
      referenceText: "",
      referenceProp1: "",
      referenceProp2: "LowValue",
      referenceProp3: "",
      referenceProp4: "",
      referenceProp5: "",
      isActive: true,
    }));

    setUpdateId("");
    setDeleteID("");
    settogglebutton("")
    setGetDataFromID("")
    setChecked("")
    setReviewerChecked("")
  };
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
    if (value === "HR") {
      setFormState((formState) => ({
        ...formState,
        referenceProp1: "1",
      }));
    } else {
      setFormState((formState) => ({
        ...formState,
        referenceProp1: "",
      }));
    }
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenModel(false);
   
    clearState(setFormState,setUpdateId,setDeleteID, settogglebutton,setGetDataFromID);

    // setErrAlertMessage("")
  };



// useEffect(()=>{
//   if(formState?.referenceProp3){
//     setFormState((formState)=>({
//       ...formState,
//       referenceProp3:"true"
//     }));

//   }else{
//     setFormState((formState)=>({
//       ...formState,
//       referenceProp3:""
//     }));
//   }
// },[formState?.referenceProp3])


  useEffect(() => {
    handleClickOpen();
    if (updateId || deleteId) {
      if (getdataFromID) {
        const update = getdata.filter(
          (value) => getdataFromID === value.referenceId
        );
        

        setFormState((formState) => ({
          ...formState,
          referenceId: Number(update[0]?.referenceId),
          referenceKey: update[0]?.referenceKey,
          referenceCode: update[0]?.referenceCode,
          referenceText: update[0]?.referenceText,
          referenceProp1: update[0]?.referenceProp1,
          referenceProp2: update[0]?.referenceProp2
            ? update[0]?.referenceProp2
            : "LowValue",
          referenceProp3: update[0]?.referenceProp3,
          referenceProp4: update[0]?.referenceProp4 || "",
          isActive: update[0]?.isActive ? true : false,
          employeeGrade:update[0]?.employeeGrade
        }));
        setChecked(update[0]?.referenceProp3 === "true" ? true:false)
        setReviewerChecked(update[0]?.referenceProp5 === true ? true:false)
      }
      // getRefrenceDataListForOneRecord (
      //   "InvoiceType",
      //   () => {},
      //   () => {},
      //   () => {},
      //   updateId,
      //   togglebutton,
      //   getdataFromID,
      //   setFormState,
      //   setChecked,
      //   () => {},


      // );
    } else if (togglebutton) {
      
      const toggle =getdata.filter(
        (value) => togglebutton === value.referenceId
      );
      

      setFormState((formState) => ({
        ...formState,
        referenceId: Number(toggle[0]?.referenceId),

        referenceKey: toggle[0]?.referenceKey,
        referenceCode: toggle[0]?.referenceCode,
        referenceText: toggle[0]?.referenceText,
        referenceProp1: toggle[0]?.referenceProp1,
        referenceProp2: toggle[0]?.referenceProp2
          ? toggle[0]?.referenceProp2
          : "LowValue",
        referenceProp3: toggle[0]?.referenceProp3,
        referenceProp4: toggle[0]?.referenceProp4 || "",
        isActive: toggle[0]?.isActive ? false : true,
      }));
      setEnable(toggle[0]?.isActive)
      // getRefrenceDataListForOneRecord (
      //   "InvoiceType",
      //   () => {},
      //   () => {},
      //   () => {},
      //   updateId,
      //   togglebutton,
      //   getdataFromID,
      //   setFormState,
      //   setChecked,
      //   () => {},

      // );
    }
    // get_Location();
  }, []);


  const options=['16','17','18','19','20','21','22','23','24','25']

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        // sx={{ width: "60%" }}
        fullWidth={true}
      >
        {deleteId ? (
          <>
            <DialogContent>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loader}
              >
                <CircularProgress color="inherit" />
              </Backdrop>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <HelpOutline color="secondary" fontSize="large" mt={2} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                p={2}
                mt={1}
              >
                <Typography variant="h4" style={{ width: "80%" }}>
                  Are you sure you want to Delete a User?
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                m={1}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                >
                  NO
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: "20px" }}
                  onClick={Delete}
                >
                  Yes
                </Button>
              </Box>
            </DialogContent>
          </>
        ) : (
          <>
            {togglebutton ? (
              <>
                <DialogContent>
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={loader}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <HelpOutline color="secondary" fontSize="large" mt={2} />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    p={2}
                    mt={1}
                  >
                    <Typography variant="h4" style={{ width: "80%" }}>
                      {enable ? "  Are you sure you want to  Disable this Item?": "  Are you sure you want to  Enable this Item?"}
                    
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    m={1}
                  >
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleClose}
                    >
                      NO
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      style={{ marginLeft: "20px" }}
                      onClick={enableDisable}
                    >
                      Yes
                    </Button>
                  </Box>
                </DialogContent>
              </>
            ) : (
              <>
                <form onSubmit={(e) => submitHandler(e)}>
                  <DialogTitle
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                  >
                    Invoice Type
                  </DialogTitle>
                  <Divider />
                  <DialogContent>
                    <Backdrop
                      sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open={loader}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                    <Grid container spacing={2} pb={3}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          id="outlined-basic"
                          label="Code"
                          name="referenceCode"
                          variant="outlined"
                          value={formState.referenceCode}
                          onChange={changeHandler}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          id="outlined-basic"
                          label="Description"
                          name="referenceText"
                          variant="outlined"
                          value={formState.referenceText}
                          onChange={changeHandler}
                          required
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl component="fieldset">
                          <Typography style={{ color: "black" }}>
                            HR / Low value:
                          </Typography>

                          <RadioGroup
                            row
                            aria-label="gender"
                            name="referenceProp2"
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            value={formState.referenceProp2}
                            onChange={changeHandler}
                          >
                            <FormControlLabel
                              value="LowValue"
                              sx={{ color: "black" }}
                              control={
                                <Radio
                                  color="primary"
                                  sx={{
                                    color: "#C5C7CD",
                                    "&.Mui-checked": {
                                      color: "#0095DA",
                                    },
                                  }}
                                  size="small"
                                />
                              }
                              label="Low Value"
                            />
                            <FormControlLabel
                              value="HR"
                              sx={{ color: "black" }}
                              control={
                                <Radio
                                  color="primary"
                                  sx={{
                                    color: "#C5C7CD",
                                    "&.Mui-checked": {
                                      color: "#0095DA",
                                    },
                                  }}
                                  size="small"
                                />
                              }
                              label="HR"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        {/* <Typography style={{color:"black"}}>
    MPAS Selection:
        </Typography>*/}
                        <FormControlLabel
                          style={{ color: "black" }}
                          label="Show to MPAS"
                          color="secondary"
                          control={
                            <Checkbox
                              color="secondary"
                              fontSize="small"
                              checked={checked}
                              name="referenceProp3"
                              onChange={(event) => {
                                setFormState((formState) => ({
                                  ...formState,
                                  referenceProp3:
                                    event.target.checked.toString(),
                                }));
                                setChecked(event.target.checked);
                              }}
                            />
                          }
                        />
                          {/* <FormControlLabel
                          style={{ color: "black" }}
                          label="Is Reviewer Mandatory"
                          color="secondary"
                          control={
                            <Checkbox
                              color="secondary"
                              fontSize="small"
                              checked={reviewerchecked}
                              name="referenceProp5"
                              onChange={(event) => {
                                setFormState((formState) => ({
                                  ...formState,
                                  referenceProp5:
                                    event.target.checked,
                                }));
                                setReviewerChecked(event.target.checked);
                              }}
                            />
                          }
                        /> */}
                         <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Autocomplete
                          options={options}
                          classes={{ option: classes.option }}
                          size="small"
                          value={formState.employeeGrade}
                          getOptionLabel={(option) =>
                            (option !== "" &&
                              `${option}` ) ||
                            ""
                          }
                          loading={""}
                          onChange={(event, value) => {
                            if (!value) {
                              setFormState((formState) => ({
                                ...formState,
                                employeeGrade:"",
                              }));
                            } else {
                              setFormState((formState) => ({
                                ...formState,
                                employeeGrade: value || "",
                              }));
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name=""
                              value={""}
                              onChange={(event) => {
                              }}
                              // required
                              onBlur={""}
                              label="Select Career Ladder"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                        {/* <FormControl fullWidth size="small">
      <InputLabel id="demo-simple-select-label">
      Select Location
      </InputLabel>
      <Select
        displayEmpty
        labelId="demo-multiple-name-label"
        label="Select Location"
        name="referenceProp3"
        value={formState.referenceProp3}
        onChange={changeHandler}
        MenuProps={MenuProps}
      >
      
      {locationOption.map((item, index) => (
        <MenuItem key={index} value={item.id}>
          {item.location}
        </MenuItem>
      ))}

      </Select>
 
      </FormControl>*/}
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <Divider />

                  <DialogActions>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    {updateId ? (
                      <Button
                        color="success"
                        variant="contained"
                         type="submit"
                          // onClick={()=>}
                      >
                        Updated
                      </Button>
                    ) : (
                      <Button
                        color="success"
                        variant="contained"
                        type="submit"
                        //   onClick={add_role_data}
                      >
                        Save
                      </Button>
                    )}
                  </DialogActions>
                </form>
              </>
            )}
          </>
        )}
      </Dialog>
    </>
  );
}
